// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion_accordion__mQlfS","title":"Accordion_title__Kf78V","is_expanded":"Accordion_is_expanded__D2dJC","content":"Accordion_content__LnQdH"};